import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CommonService} from './common.service';

@Injectable({
    providedIn: 'root'
})
export class ConsentsFormService {

    constructor(public router: Router, private commonService: CommonService) {
    }


    async showConsent(notification: any, user: any, child: any) {
        const inputConfig = {
            parentId: user.id,
            childId: child.id,
            mode: notification.mode,
            unique_id: notification.unique_id,
            notificationId: notification.id
        };
        localStorage.setItem('ConsentCustomInputConfig', JSON.stringify(inputConfig));
        await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
    }

    async duplicateForm(uniqueId: string) {
        try {
            await this.commonService.insertItem('forms/custom-duplicate', uniqueId);
        } catch (e) {
            throw e;
        }
    }

    async getPersonalForms() {
        try {
            const request = await this.commonService.getList(`forms/personal`);
            return request.object;
        } catch (e) {
            throw e;
        }
    }

    async showCustomPublicForm(form: any, isAuthenticated: boolean = false) {
        console.log(form);
        const inputConfig = {
            edit: true,
            childId: null,
            mode: false,
            parentId: null,
            unique_id: form.unique_id,
            id: form.id,
        };
        console.log(inputConfig);
        // parentRequestForm?isExternal=true&mode=false&unique_id=xmr4grv8ddt
        if(isAuthenticated) {
            await this.router.navigate(['/home/publicRequestForm'], {queryParams: inputConfig});
        } else {
            await this.router.navigate(['/publicForm'], {queryParams: inputConfig});
        }
    }

    async showCustomForm(notification: any, user: any, child: any) {
        const inputConfig = {
            parentId: user.id,
            childId: child ? child.id : user.id,
            unique_id: notification.unique_id,
        };
        localStorage.setItem('ConsentCustomInputConfig', JSON.stringify(inputConfig));
        await this.router.navigate(['/home/parentRequestForm'], {queryParams: inputConfig});
    }

    // Single User Model - user acts for themselves
    async showUserForm(notification: any, user: any) {
        const inputConfig = {
            parentId: user.id,
            childId: user.id,
            userId: user.id,
            unique_id: notification.unique_id,
        };
        localStorage.setItem('ConsentCustomInputConfig', JSON.stringify(inputConfig));
        await this.router.navigate(['/home/parentRequestForm'], {queryParams: inputConfig});
    }

    async getCustomCompletedFormChildResults(childId, uniqueId) {
        try {
            const request = await this.commonService.getList(`forms/custom/completed/results?childId=${childId}&uniqueId=${uniqueId}`);
            return request.object;
        } catch (e) {
            throw e;
        }
    }

    async getCustomFormChildResults(childId, uniqueId, id?: number) {
        try {
            let request;
            if (id !== undefined) {
                request = await this.commonService.getList(`forms/custom/results?childId=${childId}&uniqueId=${uniqueId}&id=${id}`);
            } else {
                request = await this.commonService.getList(`forms/custom/results?childId=${childId}&uniqueId=${uniqueId}`);
            }
            return request.object;
        } catch (e) {
            throw e;
        }
    }

    async getCustomCompletedFormParentResults(parentId: number, uniqueId: string, id?: number, formId?: number) {
        try {
            let request;
            if (id !== undefined) {
                request = await this.commonService.getList(`forms/custom/parents/results?childId=${parentId}&uniqueId=${uniqueId}&id=${id}`);
            } else if (formId) {
                request = await this.commonService.getList(`forms/custom/parents/results?childId=${parentId}&uniqueId=${uniqueId}&formId=${formId}`);

            } else {
                request = await this.commonService.getList(`forms/custom/parents/results?childId=${parentId}&uniqueId=${uniqueId}`);
            }
            return request.object;
        } catch (e) {
            throw e;
        }
    }

    async getCustomFormByUniqueId(uniqueId) {
        try {
            const request = await this.commonService.getList(`forms/custom?uniqueId=${uniqueId}`);
            if (request.object.length > 0) {
                return request.object[0];
            } else {
                return null;
            }
        } catch (e) {
            throw e;
        }
    }
}
